import {
  CircleGeometry,
  DoubleSide,
  Mesh,
  MeshBasicMaterial,
  Object3D,
  Vector3,
} from "three";
import { JointPositions } from "../types";
import { alphaFilter } from "./util";

// TODO: decide if we want polymorphic group that is also implemented as
//       a height map
export class PositionDetails {
  ground = new Vector3();
  centroid = new Object3D();

  groundLevel?: number = undefined;
  private offset = -0.1;
  private excludedPoints;

  constructor(excludedPoints: string[] = []) {
    this.excludedPoints = excludedPoints;
  }

  update(targets: JointPositions, reset: boolean = false) {
    // const points = Object.values(targets.points);

    let minY: number | undefined = undefined;
    let avX = 0;
    let avY = 0;
    let avZ = 0;
    let cnt = 0;
    for (const name in targets.points) {
      const point = targets.get(name);
      if (point && !this.excludedPoints.includes(name)) {
        avX += point.x;
        avY += point.y;
        avZ += point.z;
        if (minY == undefined || point.y < minY) {
          minY = point.y;
        }
        cnt++;
      }
    }

    avX /= cnt;
    avY /= cnt;
    avZ /= cnt;

    if (this.groundLevel == undefined || reset) {
      this.groundLevel = minY;
    } else if (minY) {
      const low = alphaFilter(this.groundLevel, minY, 0.01);
      const high = alphaFilter(this.groundLevel, minY, 0.5);
      this.groundLevel = Math.min(low, high);
    }

    const level = (this.groundLevel ?? 0) + this.offset;

    this.ground.set(avX, level, avZ);
    this.centroid.position.set(avX, avY, avZ);
  }
}

export function makeGroundSpot(): Mesh {
  const geom = new CircleGeometry(5, 32);
  const material = new MeshBasicMaterial({ color: 0xffff00 });
  material.side = DoubleSide;

  const groundSpot = new Mesh(geom, material);
  groundSpot.rotateX(Math.PI / 2);

  return groundSpot;
}
